// Helper functions for update profile information for developers

export const formatData = (newObject, keys) => {
  for (const key of keys) {
    const value = newObject[key];
    if (key === 'profession' || key === 'languages') {
      if (typeof newObject[key] === 'string' && newObject[key].includes(',')) {
        console.log('key exception: ' + key);
        const toArray = newObject[key].split(',');
        //Capitalize all elements in the array
        const newArray = toArray.map((item) => {
          return capitalize(item);
        });
        newObject[key] = newArray;
      } else {
        newObject[key] = capitalize(value);
      }
    } else if (key === 'education' || key === 'location') {
      newObject[key] = capitalize(value);
    }

    if (typeof value === 'object' && !Array.isArray(value)) {
      if (key === 'preferences') {
        const subKeys = Object.keys(value);
        for (const key of subKeys) {
          if (
            key === 'role' ||
            key === 'officePref' ||
            key === 'jobTypes' ||
            key === 'locations'
          ) {
            if (typeof value[key] === 'string' && value[key].includes(',')) {
              console.log('I am string and has a comma');
              const toArray = value[key].split(',');

              //Capitalize all elements in the array
              const newArray = toArray.map((item) => {
                return capitalize(item);
              });
              value[key] = newArray;
            }
          }
        }
      }
    }
  }
};

const capitalize = (item) => {
  //Placeholder for the new capitalized word to be created
  let arr = [];

  //Remove whitespace
  item = item.trim();

  //For every letter in item, push to array "arr"
  for (let i = 0; i < item.length; i++) {
    //make first letter capitalized
    if (i === 0) {
      arr.push(item[i].toUpperCase());
    } else {
      arr.push(item[i]);
    }
  }
  item = arr.join('');
  return item;
};
